import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { IconBlob } from "@/components/IconBlob";
import { findSections } from "@/data/searchKeywords";

export function SectionSuggestions({ query, mode = "need", title = "Sezioni consigliate" }) {
  const { categories, catName } = useApp();
  const navigate = useNavigate();
  const items = findSections(query, categories, catName);
  if (!items.length) return null;
  const go = (it) => navigate(mode === "help" ? `/category/${it.cat}` : `/publish/${it.cat}${it.sub ? `?sub=${it.sub}` : ""}`);
  return (
    <div data-testid="section-suggestions" className="mb-4">
      <p className="text-xs font-bold uppercase tracking-wide text-[#4A4E68] mb-2">{title}</p>
      <div className="grid gap-2">
        {items.map((it) => (
          <button key={`${it.cat}-${it.sub || ""}`} data-testid={`suggestion-${it.cat}${it.sub ? `-${it.sub}` : ""}`} onClick={() => go(it)}
            className="group w-full min-w-0 overflow-hidden bg-white rounded-[18px] p-3 flex items-center gap-3 text-left">
            <IconBlob icon={it.icon} seed={it.cat} size={22} />
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-extrabold text-[#0F1230] truncate">{it.label}{it.subLabel ? ` · ${it.subLabel}` : ""}</span>
              <span className="block text-xs text-[#4A4E68]">{mode === "help" ? "Vedi le richieste" : "Pubblica qui la tua richiesta"}</span>
            </span>
            <ArrowRight size={18} className="text-[#1F4FE0] group-hover:translate-x-1 transition-transform duration-150" />
          </button>
        ))}
      </div>
    </div>
  );
}
